/* BAYRUE — guided bundle selector ("Concept B").

   The rule this file exists to enforce: it must be impossible to submit an incomplete or
   unavailable selection, and the reason must always be visible. Everything else is detail.

   Discounts are Kaching's job. This adds the right quantity to the cart and lets the cart
   apply the money. Tier figures shown here are display-only merchant settings. */
(function () {
  'use strict';

  /* shop.money_format is an HTML STRING - on this store it is
     "<span class=money>${{amount}}</span>", because the currency converter keys off that
     .money element. Writing it with createTextNode printed the tag on the button as
     "<SPAN CLASS=MONEY>$39.99</SPAN>" (uppercased by the CTA's text-transform). It has to
     be assigned as HTML so the span becomes a real element and the converter can find it.
     The value comes from a shop setting, not from anything a shopper can type. */
  function setMoney(el, cents, format) {
    el.innerHTML = formatMoney(cents, format);
  }

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    // Handle the common Shopify money formats without pulling in a library.
    if (/amount_no_decimals\b/.test(format)) amount = Math.round(cents / 100).toString();
    if (/with_comma_separator/.test(format)) amount = amount.replace('.', ',');
    var withThousands = amount.replace(/\B(?=(\d{3})+(?!\d))/g, /with_comma_separator/.test(format) ? '.' : ',');
    var out = format.replace(/\{\{\s*\w+\s*\}\}/, withThousands);
    // If the format string was unusable, fall back to something readable rather than blank.
    return out === format ? '$' + amount : out;
  }

  var Bundle = function () {
    return Reflect.construct(HTMLElement, [], Bundle);
  };
  Bundle.prototype = Object.create(HTMLElement.prototype);
  Bundle.prototype.constructor = Bundle;
  Object.setPrototypeOf(Bundle, HTMLElement);

  Bundle.prototype.connectedCallback = function () {
    if (this._booted) return;
    this._booted = true;

    var raw = this.querySelector('.js-bayrue-data');
    try {
      this.data = JSON.parse(raw.textContent);
    } catch (e) {
      return; // Malformed product data — leave the theme's own form in charge.
    }

    this.optionNames = (this.data.options || []).map(function (o) {
      return typeof o === 'string' ? o : o.name;
    });
    this.optionValues = (this.data.options || []).map(function (o) {
      return typeof o === 'string' ? [] : (o.values || []).map(function (v) {
        return typeof v === 'string' ? v : v.name;
      });
    });

    this.moneyFormat = this.getAttribute('data-money-format') || '${{amount}}';
    this.noun = this.getAttribute('data-noun') || 'item';
    this.nounPlural = this.getAttribute('data-noun-plural') || 'items';

    this.listEl = this.querySelector('.js-bayrue-list');
    this.progressEl = this.querySelector('.js-bayrue-progress');
    this.addBtn = this.querySelector('.js-bayrue-add');
    this.ctaLabel = this.querySelector('.js-bayrue-cta-label');
    this.totalEl = this.querySelector('.js-bayrue-total');
    this.noteEl = this.querySelector('.js-bayrue-note');

    this.ctaReady = this.addBtn.getAttribute('data-label-ready') || 'Add to cart';
    this.ctaIncomplete = this.ctaLabel.textContent.trim();

    var self = this;
    this.tierBtns = [].slice.call(this.querySelectorAll('.js-bayrue-tier'));
    this.tierBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { self.setTier(btn); });
    });

    this.addBtn.addEventListener('click', function () { self.addToCart(); });

    // Open on the tier the merchant marked, else the first one.
    var preferred = this.querySelector('.js-bayrue-tier[data-default="true"]') || this.tierBtns[0];
    if (preferred) this.setTier(preferred);
  };

  Bundle.prototype.setTier = function (btn) {
    this.tierBtns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    this.qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    this.free = parseInt(btn.getAttribute('data-free'), 10) || 0;
    this.percent = parseFloat(btn.getAttribute('data-percent')) || 0;

    // Keep any choices already made when the shopper changes their mind about quantity.
    var prev = this.picks || [];
    this.picks = [];
    for (var i = 0; i < this.qty; i++) {
      this.picks.push(prev[i] ? prev[i].slice() : new Array(this.optionNames.length).fill(null));
    }
    this.renderList();
  };

  /* Is there any available variant matching this partial selection? */
  Bundle.prototype.canMatch = function (partial) {
    return this.data.variants.some(function (v) {
      if (!v.available) return false;
      return partial.every(function (val, idx) { return val === null || v.options[idx] === val; });
    });
  };

  Bundle.prototype.variantFor = function (sel) {
    return this.data.variants.find(function (v) {
      return v.available && sel.every(function (val, idx) { return v.options[idx] === val; });
    }) || null;
  };

  Bundle.prototype.renderList = function () {
    var self = this;
    this.listEl.innerHTML = '';

    this.picks.forEach(function (sel, unit) {
      var variant = self.variantFor(sel);
      var complete = !!variant;
      // With "buy 2 get 1 free", the free units are the last ones in the set.
      var isFree = self.free > 0 && unit >= self.qty - self.free;

      var row = document.createElement('div');
      row.className = 'bayrue-bundle__row';
      row.dataset.todo = complete ? '0' : '1';

      var head = document.createElement('div');
      head.className = 'bayrue-bundle__row-head';

      var mark = document.createElement('span');
      mark.className = 'bayrue-bundle__mark';
      mark.textContent = complete ? '✓' : String(unit + 1);
      head.appendChild(mark);

      var name = document.createElement('span');
      name.className = 'bayrue-bundle__row-name';
      var label = self.noun.charAt(0).toUpperCase() + self.noun.slice(1) + ' ' + (unit + 1);
      name.textContent = complete ? label + ' · ' + sel.join(' / ') : label;
      head.appendChild(name);

      if (isFree) {
        var tag = document.createElement('span');
        tag.className = 'bayrue-bundle__free-tag';
        tag.textContent = 'Free';
        head.appendChild(tag);
      }
      row.appendChild(head);

      self.optionNames.forEach(function (optName, optIdx) {
        var wrap = document.createElement('div');
        wrap.className = 'bayrue-bundle__opt';

        var lbl = document.createElement('span');
        lbl.className = 'bayrue-bundle__opt-name';
        lbl.textContent = sel[optIdx] ? optName : 'Choose a ' + optName.toLowerCase();
        wrap.appendChild(lbl);

        var chips = document.createElement('div');
        chips.className = 'bayrue-bundle__chips';

        self.optionValues[optIdx].forEach(function (value) {
          var probe = sel.slice();
          probe[optIdx] = value;
          var reachable = self.canMatch(probe);

          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'bayrue-bundle__chip';
          chip.textContent = value;
          chip.setAttribute('aria-pressed', sel[optIdx] === value ? 'true' : 'false');
          if (!reachable) {
            chip.disabled = true;
            chip.title = value + ' is not available';
          }
          chip.addEventListener('click', function () {
            self.picks[unit][optIdx] = value;
            // Drop any later choices this one just invalidated.
            for (var k = 0; k < self.optionNames.length; k++) {
              if (k === optIdx) continue;
              var test = self.picks[unit].slice();
              if (test[k] !== null && !self.canMatch(test)) self.picks[unit][k] = null;
            }
            self.renderList();
            self.showInGallery(self.picks[unit]);
          });
          chips.appendChild(chip);
        });

        wrap.appendChild(chips);
        row.appendChild(wrap);
      });

      self.listEl.appendChild(row);
    });

    this.refreshState();
  };

  /* Point the main gallery at whatever the shopper just chose.

     Rather than reimplement "which image belongs to this variant", this checks the
     theme's OWN variant picker and fires its change event. Berlin then does everything
     it does when a real pill is clicked: swaps the gallery, moves the thumbnail rail,
     updates the colour label and the URL. Nothing here has to know how that works, so a
     theme update cannot leave it out of step.

     Verified the bundle survives that round trip - Berlin re-renders the product info on
     variant change, but the <bayrue-bundle> element is the same node afterwards with its
     rows and the shopper's choices intact. */
  Bundle.prototype.showInGallery = function (sel) {
    var scope = this.closest('.product') || document;
    var picker = scope.querySelector('variant-radios, variant-selects');
    if (!picker) return;

    var touched = null;
    for (var i = 0; i < this.optionNames.length; i++) {
      var value = sel[i];
      if (value === null || value === undefined) continue;
      var name = this.optionNames[i];

      // Button picker: a radio per value, named after the option.
      var radios = picker.querySelectorAll('input[type="radio"]');
      for (var j = 0; j < radios.length; j++) {
        if (radios[j].name === name && radios[j].value === value) {
          if (!radios[j].checked) {
            radios[j].checked = true;
            touched = radios[j];
          }
          break;
        }
      }

      // Dropdown picker: one select per option.
      var selects = picker.querySelectorAll('select');
      for (var m = 0; m < selects.length; m++) {
        if (selects[m].name === name && selects[m].value !== value) {
          selects[m].value = value;
          touched = selects[m];
        }
      }
    }

    // One event is enough: the picker reads every control when it handles a change.
    if (touched) touched.dispatchEvent(new Event('change', { bubbles: true }));
  };

  Bundle.prototype.missingUnits = function () {
    var self = this;
    return this.picks
      .map(function (sel, i) { return self.variantFor(sel) ? null : i + 1; })
      .filter(function (n) { return n !== null; });
  };

  Bundle.prototype.refreshState = function () {
    var self = this;
    var missing = this.missingUnits();
    var done = this.qty - missing.length;

    this.progressEl.textContent = done + ' of ' + this.qty + ' chosen';

    // Price the units that are actually chosen; the free ones are the cheapest, so the
    // shopper is never shown a saving larger than they will get.
    var prices = this.picks.map(function (sel) {
      var v = self.variantFor(sel);
      return v ? v.price : null;
    }).filter(function (p) { return p !== null; }).sort(function (a, b) { return a - b; });

    var payable = prices.slice(this.free);
    var subtotal = payable.reduce(function (a, b) { return a + b; }, 0);
    if (this.percent > 0) subtotal = Math.round(subtotal * (1 - this.percent / 100));
    var full = prices.reduce(function (a, b) { return a + b; }, 0);

    this.totalEl.innerHTML = '';
    if (prices.length) {
      var now = document.createElement('span');
      setMoney(now, subtotal, this.moneyFormat);
      this.totalEl.appendChild(now);
      if (full > subtotal) {
        var was = document.createElement('span');
        was.className = 'bayrue-bundle__cta-was';
        setMoney(was, full, this.moneyFormat);
        this.totalEl.appendChild(was);
      }
    }

    this.addBtn.disabled = missing.length > 0;
    this.ctaLabel.textContent = missing.length ? this.ctaIncomplete : this.ctaReady;

    if (missing.length) {
      this.noteEl.removeAttribute('data-state');
      this.noteEl.textContent =
        'Still to choose: ' + this.noun + ' ' + missing.join(', ');
    } else if (full > subtotal) {
      this.noteEl.removeAttribute('data-state');
      this.noteEl.innerHTML =
        'You save <b>' + formatMoney(full - subtotal, this.moneyFormat) + '</b> on this set.';
    } else {
      this.noteEl.removeAttribute('data-state');
      this.noteEl.textContent = '';
    }
  };

  Bundle.prototype.addToCart = function () {
    var self = this;
    if (this.missingUnits().length) return;

    // Merge duplicate variants so the cart shows one line with a quantity, not repeats.
    var counts = {};
    this.picks.forEach(function (sel) {
      var v = self.variantFor(sel);
      counts[v.id] = (counts[v.id] || 0) + 1;
    });
    var items = Object.keys(counts).map(function (id) {
      return { id: parseInt(id, 10), quantity: counts[id] };
    });

    this.addBtn.disabled = true;
    this.ctaLabel.textContent = 'Adding…';
    this.noteEl.removeAttribute('data-state');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function () {
        self.ctaLabel.textContent = self.ctaReady;
        self.addBtn.disabled = false;
        // Let the cart drawer — Berlin's or Kaching's — pick this up however it listens.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        if (window.Shopify && window.Shopify.onCartUpdate) window.Shopify.onCartUpdate();
        var opener = document.querySelector('#cart-icon-bubble, .header__icon--cart');
        if (opener) opener.click();
      })
      .catch(function () {
        self.addBtn.disabled = false;
        self.ctaLabel.textContent = self.ctaReady;
        self.noteEl.setAttribute('data-state', 'error');
        self.noteEl.textContent = 'We could not add that to your cart. Please try again.';
      });
  };

  if (!window.customElements.get('bayrue-bundle')) {
    window.customElements.define('bayrue-bundle', Bundle);
  }
})();
